import upperCase from 'lodash/toUpper'

export const createAsyncType = (name: any) => ({
  REQUEST: upperCase(`REQUEST_${name}`),
  SUCCESS: upperCase(`SUCCESS_${name}`),
  FAILURE: upperCase(`FAILURE_${name}`),
})
